import { useGQL } from 'services/gql';
import { userSchema } from './userSchema';
import { breakoutRoomInviteSchema } from '../breakoutRoomInvite/breakoutRoomInviteSchema';

const getUserByEmailKey = /* GraphQL */ `
    query getUserKey($email: String, $nextToken: String){
      listUserByEmail(email: $email, nextToken: $nextToken) {
        nextToken
        items {
          ${userSchema}
        }
      }
    }
`;

const listUsers = /* GraphQL */ `
    query listUsers($nextToken: String){
      listUsers(nextToken: $nextToken){
        nextToken
        items {
          ${userSchema}
        }
      }
    }
`;

const getCompleteUserByEmail = /* GraphQL */ `
    query getUser($email: String, $nextToken: String){
      listUsers(filter: {email: {eq: $email}}, nextToken: $nextToken) {
        nextToken
        items {
          ${userSchema}
          myBreakoutRoomInvitations(limit: 100000) {
            items {
              ${breakoutRoomInviteSchema}
            }
          }
        }
      }
    }
`;

export const useUserGql = () => {
  const {
    createMutation,
    createMultipleMutation,
    updateMutation,
    sendQuery,
    getGraphqlDynamicFilter,
  } = useGQL('user');

  //QUERY
  const get = async (email, query, limitless) => {
    const listResult = await sendQuery(
      'get-by-email',
      query || getUserByEmailKey,
      {
        email,
      },
      limitless
    );
    if (listResult?.items) {
      return listResult.items[0];
    } else {
      return null;
    }
  };

  const list = async (query, variables, limitless) => {
    const listResult = await sendQuery(
      'list-users',
      query || listUsers,
      variables,
      limitless
    );
    if (listResult?.items) {
      return listResult.items;
    } else {
      return null;
    }
  };

  const getFiltered = async (emails) => {
    const emailFilter = getGraphqlDynamicFilter({
      orFilter: {
        paramKey: 'email',
        arrayOfElem: emails,
      },
    });

    const getUserByEmailFiltered = /* GraphQL */ `
        query getUser($nextToken: String){
          listUsers(${emailFilter}, nextToken: $nextToken) {
            nextToken
            items {
              ${userSchema}
            }
          }
        }
    `;
    const res = await list(getUserByEmailFiltered, null, true);
    return res;
  };

  const getCompleteUser = async (email) => {
    return get(email, getCompleteUserByEmail, true);
  };

  //MUTATION
  const create = (input) => createMutation(input);
  const createMultiple = (inputList) => createMultipleMutation(inputList);
  const update = (input) => updateMutation(input);

  return {
    get,
    getFiltered,
    getCompleteUser,
    list,
    create,
    createMultiple,
    update,
  };
};
